import { createContext } from 'react';

import { CompanyClubContextValue } from './company-club.type';
import { companyClubEmptyState, defaultCompanyClubContextState } from './constants';

/**
 * The context object only. The provider lives in `companyClub-provider.tsx`.
 *
 * Split so the consumers of this context stop inheriting the provider's graph — PostHog,
 * the auth and company-auth contexts, `useGetCompanyClub`, `shouldShowFloorplanV2` —
 * when almost none of them render it (B2B-2142). Do not re-export it from here.
 */
export const CompanyClubContext = createContext<CompanyClubContextValue>({
  ...companyClubEmptyState,
  setCompanyClubState: () => {},
  setCompanyState: () => {},
  setClubState: () => {},
  setEmptyCompanyClubState: () => {},
  isTestVenueCompany: false,
  isExternalPlatformEnabledForCompany: false,
  isFloorplanV2Active: false,
  isExtraGuestsForBottleServiceActive: false,
  isAdmissionImageGalleryActive: false,
  isAddonImageGalleryActive: false,
  isAdmissionIncludeDrinksActive: false,
  isAddonTermsAndConditionsLinkActive: false,
  isWidgetSignInEnabled: false,
  isWidgetResaleActive: false,
  isWidgetEmbedGeneratorActive: false,
  isSecretLocationActive: false,
  isOrganizerPublicProfileActive: false,
  isDelayedDeliveryActive: false,
  isResaleSettingsActive: false,
  isTicketAlertsSettingsActive: false,
  resaleSettingsVisibility: defaultCompanyClubContextState.resaleSettingsVisibility,
  isEventReportResaleActive: false,
  isEventReportSalesPaceActive: false,
  isEventReportTicketAlertsActive: false,
  isAddOrganizerToVenueActive: false,
  isAddOrganizerToVenueLoading: false,
  isVideoCoverUploadActive: false,
  isLoadingCompanyClub: false,
  venueAccess: null,
});
